import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background: #222;
  color: #ecf0f1;
  margin-top: auto;
`;

const FooterBottom = styled.div`
  background: #222;
  padding: 20px 0;
`;

const FooterBottomInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  font-size: 14px;
  color: #95a5a6;
  margin: 0;
`;

const FooterInfos = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
  text-align: left;
  word-break: keep-all;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const Logo = styled(Link)`
  font-size: 24px;
  font-weight: bold;
  color: #3498db;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: color 0.3s;

  img {
    height: 40px;
    transition: filter 0.3s;
  }

  span {
    @media (max-width: 480px) {
      display: none;
    }
  }
`;

const Info = styled.div`
  display: flex;
  gap: 10px;
  font-size: 14px;
  color: #95a5a6;
  
  @media (max-width: 1024px) {
    display: table;
    width: 100%;
  }
`;

const InfoTitle = styled.span`
  color: #aaaaaa;
  font-weight: 500;
  
  @media (max-width: 1024px) {
    display: table-cell;
    width: 80px;
    min-width: 80px;
    vertical-align: top;
  }
`;

const InfoContent = styled.span`
  @media (max-width: 1024px) {
    display: table-cell;
    padding-left: 10px;
  }
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterBottom>
        <FooterBottomInner>
          <Logo to="/">
            <img
              src={`${process.env.PUBLIC_URL}/images/1main/logo.png`}
              alt="Company Logo"
            />
          </Logo>

          <FooterInfos>
            <Info>
              <InfoTitle>회사명</InfoTitle>
              <InfoContent>주식회사 이알씨</InfoContent>
            </Info>
            <Info>
              <InfoTitle>대표</InfoTitle>
              <InfoContent>장석영</InfoContent>
            </Info>
            <Info>
              <InfoTitle>주소</InfoTitle>
              <InfoContent>
                경기도 수원시 영통구 신원로 88 103-1007 (신동, 디지털엠파이어Ⅱ)
              </InfoContent>
            </Info>
            <Info>
              <InfoTitle>대표번호</InfoTitle>
              <InfoContent>031-695-7090~2</InfoContent>
            </Info>
            <Info>
              <InfoTitle>이메일</InfoTitle>
              <InfoContent>info@erc.co.kr</InfoContent>
            </Info>
          </FooterInfos>
          <Copyright>
            © {currentYear} Copyright ERC Corp. ALL RIGHTS RESERVED.
          </Copyright>
        </FooterBottomInner>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
